"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Calculator, FileText, Users, CalendarCheck, Briefcase, Landmark, ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";
const services = [{
  title: "Company Tax",
  fullTitle: "Cálculo e Gestão de Company Tax",
  description: "Otimize a carga tributária da sua empresa com nossa gestão especializada e em total conformidade com o Revenue irlandês.",
  icon: Calculator,
  link: "#contato"
}, {
  title: "VAT",
  fullTitle: "Registro e Declaração de VAT",
  description: "Garantimos a conformidade do seu negócio com registros e declarações de VAT precisos, evitando multas e atrasos.",
  icon: FileText,
  link: "#contato"
}, {
  title: "Folha de Pagamento",
  fullTitle: "Gestão de Folha de Pagamento",
  description: "Processamento completo e seguro da folha de pagamento para sua equipe, garantindo os direitos e deveres fiscais.",
  icon: Users,
  link: "#contato"
}, {
  title: "Annual Return",
  fullTitle: "Entrega de Annual Return",
  description: "Evite penalidades com a entrega pontual e correta do seu Annual Return ao Companies Registration Office (CRO).",
  icon: CalendarCheck,
  link: "#contato"
}, {
  title: "Contabilidade",
  fullTitle: "Organização Contábil",
  description: "Mantenha suas finanças em ordem com nossa contabilidade dedicada para empresas e profissionais autônomos.",
  icon: Briefcase,
  link: "#contato"
}, {
  title: "Self-Employed",
  fullTitle: "Abertura de Atividade",
  description: "Inicie sua jornada na Irlanda com suporte completo para registro e manutenção como Self-Employed.",
  icon: Landmark,
  link: "#contato"
}];
export default function SolucoesContabeisEspecializadas() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="soluções-contábeis-especializadas" className="dark bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div ref={headerRef} className={cn("max-w-3xl mb-16 transition-all duration-700 ease-out", isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          <h2 className="text-3xl font-bold mb-6 text-foreground !font-sans md:text-4xl lg:text-5xl">Soluções Contábeis Especializadas</h2>
          <p className="text-lg text-muted-foreground">
            Serviços sob medida para garantir a conformidade fiscal, evitar multas e impulsionar o crescimento seguro do seu negócio na Irlanda.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, i) => {
          const {
            ref: cardRef,
            isVisible: isCardVisible
          } = useRevealOnScroll({
            threshold: 0.1
          });
          const isLarge = i < 2;
          return <div key={i} data-index={i} ref={cardRef} className={cn("group transition-all duration-700 ease-out", isLarge ? "lg:col-span-2 md:col-span-2" : "lg:col-span-1 md:col-span-1", isCardVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <Card className="h-full bg-white border-[hsl(160,15%,88%)] hover:border-[hsl(45,90%,50%)] hover:scale-[1.02] transition-all duration-300 flex flex-col overflow-hidden shadow-lg">
                  <CardHeader className="pb-4">
                    <div className="size-12 rounded-lg bg-[hsl(160,45%,10%)]/5 flex items-center justify-center mb-4">
                      <service.icon className="size-6 text-[hsl(45,90%,45%)]" />
                    </div>
                    <CardTitle className="font-semibold text-[hsl(160,45%,10%)] text-xl leading-tight !font-sans md:text-2xl">
                      {isLarge ? service.fullTitle : service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="flex-grow">
                    <p className="text-[hsl(160,15%,35%)] line-clamp-2 text-sm md:text-base">
                      {service.description}
                    </p>
                  </CardContent>
                  <CardFooter className="pt-0 mt-auto">
                    <Link to={service.link} className="inline-flex items-center gap-2 text-[hsl(160,45%,10%)] font-medium text-sm group-hover:text-[hsl(45,90%,45%)] transition-colors">
                      Saiba Mais 
                      <ArrowRight className="size-4 transition-transform group-hover:translate-x-1" />
                    </Link>
                  </CardFooter>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}